import {productFeaturesSettings, ProductFeaturesSettings} from '../../../bps/components/productFeatures/productFeaturesSettings';

productFeaturesSettings.isInitiallyOpen = false;

export {productFeaturesSettings, ProductFeaturesSettings};